export const HYPERTEST_CONCURRENCY_ESTIMATE_TIME_REQUEST =
  'HYPERTEST_CONCURRENCY_ESTIMATE_TIME_REQUEST';
export const HYPERTEST_CONCURRENCY_ESTIMATE_TIME_RESPONSE =
  'HYPERTEST_CONCURRENCY_ESTIMATE_TIME_RESPONSE';
export const HYPERTEST_CONCURRENCY_ESTIMATE_TIME_RESET =
  'HYPERTEST_CONCURRENCY_ESTIMATE_TIME_RESET';
